import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { HotkeysProvider } from '@tanstack/react-hotkeys';
import { ToastProvider } from '@dwelling/ui';
import { ScratchFeedback } from '@fldr/scratch';
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@dwelling/ui/tokens.css';
import './styles.css';
import { routeTree } from './routeTree.gen';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 10_000, retry: false }, mutations: { retry: false } },
});

const router = createRouter({ routeTree, context: { queryClient } });

declare module '@tanstack/react-router' {
  interface Register { router: typeof router }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <HotkeysProvider>
          <RouterProvider router={router} context={{ queryClient }} />
        </HotkeysProvider>
      </ToastProvider>
    </QueryClientProvider>
    {!import.meta.env.DEV && (
      <ScratchFeedback
        isDevelopment={false}
        feedbackUrl="/api/feedback"
        feedbackContext={{ app: 'Dwelling', surface: 'design-studio' }}
        primaryColor="green"
      />
    )}
  </React.StrictMode>,
);
